var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('TreeMarker',{attrs:{"icon":_vm.icon,"lat":_vm.lat,"lng":_vm.lng,"id":_vm.treeId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }